import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"; 
import { observer } from "mobx-react-lite";
import axios from "axios";
import { useStore } from "../../stores/root-store-context";
import ShortLayout from "../../components/layout/ShortLayout";
import KanbanTasks from "../KanbanTasks/KanbanTasks";
import ProjectTabs from "../Projects/ProjectTabs";
import ProjectPage from "../Projects/ProjectPage";
import Preloader from "../../components/elements/Preloader"; 

const AnonymousPage = observer(() => {
  const location = useLocation();
  const navigate = useNavigate(); 
  const { anonymousStore, apiStore } = useStore();
  
  const [activeTab, setActiveTab] = useState<'info' | 'tasks'>('info');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) {
      navigate('/link-expired', { replace: true });
      return;
    }

    const initData = async () => {
      
      apiStore.setConfigApi({
        token,
        companyId: "0",
        userId: 0,
      });

      try {
        const base = (apiStore && apiStore.CommonApiClient && apiStore.CommonApiClient.BASE_URL) || `${window.location.protocol}//${window.location.hostname}`;
        const res = await axios.get(`/api/OpenProjectApi/project/statuses`, {
          baseURL: base,
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.status === 200) {
          await Promise.all([
            anonymousStore.getTaskStatuses(),
            anonymousStore.getTasks(),
          ]);
        } else {
          console.warn('Anonymous validation returned non-200:', res.status);
          navigate('/link-expired', { replace: true });
        }
      } catch (error) {
        console.error("Token is invalid or request failed, redirecting to expired page...", error);
        navigate('/link-expired', { replace: true });
      } 
    };

    initData();

    if (location.pathname.includes("/tasks")) {
      setActiveTab("tasks");
    } else {
      setActiveTab("info");
    }
  }, [location.search, location.pathname, apiStore, anonymousStore, navigate]);

  return (
    <ShortLayout headerStyle={1} footerStyle={2}>
      <div style={{ padding: 20 }}>
        <ProjectTabs
          isAnonymous={true}
          onTabChange={(key) => setActiveTab(key as 'info' | 'tasks')}
        />

        {activeTab === 'tasks' ? (
          <KanbanTasks
            isShowInternalLoader={anonymousStore.isLoading}
            isAnonymous={true}
            getTaskByIdProp={anonymousStore.getTaskById}
            getTaskCommentsProp={anonymousStore.getTaskComments}
            getTaskChangesProp={anonymousStore.getTaskChanges}
            createCommentProp={anonymousStore.createComment}
            getTaskAttachmentsProp={anonymousStore.getAttachments}
            uploadTaskAttachmentProp={anonymousStore.uploadTaskAttachment}
            updateTaskScheduledAndPriorityProp={anonymousStore.updateTaskScheduledAndPriority}
            getTaskTimeMetricsProp={anonymousStore.getTaskTimeMetrics}
          />
        ) : (
          <ProjectPage
            isShowInternalLoader={false}
            isAnonymous={true}
            getDocumentationByProjectProp={anonymousStore.getDocumentationByProject}
          />
        )}
      </div>
    </ShortLayout>
  );
});

export default AnonymousPage;